// export const dynamic = 'force-dynamic'
import React from 'react'
import { Metadata } from 'next';
import urls from '@/utils/urls/urls';
import cl from '@/utils/console/cl';
import ContactForm from '@/components/Contact/ContactForm';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';

export const dynamic = 'force-dynamic'
export const metadata: Metadata = {
    title: 'Contact Us | TEX EXCELLENCE LIMITED',
    description: 'Contact Us | TEX EXCELLENCE LIMITED',
}

export default async function ContactPage() {

    const res = await fetch(urls?.footer, {
        cache: 'no-store'
    });
    const data = await res.json();

    const contact = await data?.data[0] || {};
    // console.log("footer contact:", contact);
    return (
        <div className="bg-white">
            <>

                {/* sidebar-popup end */}
                <main className="main">
                    {/* breadcrumb */}
                    <div
                        className="site-breadcrumb"
                        style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
                    >
                        <div className="container">
                            <h2 className="breadcrumb-title">Contact Us</h2>
                            <ul className="breadcrumb-menu">
                                <li>
                                    <a href="index-2">Home</a>
                                </li>
                                <li className="active">Contact Us</li>
                            </ul>
                        </div>
                    </div>
                    {/* breadcrumb end */}
                    {/* contact area */}
                    <div className="contact-area py-120">
                        <div className="container">
                            <div className="contact-content">
                                <div className="row">
                                    <div className="col-md-3">
                                        <AnimationWrapper animation="fade-left" delay={0}>
                                            <div className="contact-info contact-card ">
                                                <div className="icon">
                                                    <i className="fal fa-map-location-dot" />
                                                </div>
                                                <div className="content">
                                                    <h5>Office Address</h5>
                                                    <p className='text-add'>
                                                        {/* Road. 02 Banani Chairman Bari, Banani, Dhaka-1213, Bangladesh */}
                                                        {contact?.address}
                                                    </p>
                                                </div>
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                    <div className="col-md-3">
                                        <AnimationWrapper animation="fade-left" delay={0.2}>
                                            <div className="contact-info contact-card">
                                                <div className="icon">
                                                    <i className="fal fa-phone-volume" />
                                                </div>
                                                <div className="content">
                                                    <h5>Call Us</h5>
                                                    {/* <p>+880 1713 008 736</p> */}
                                                    <p>{contact?.mobile}</p>
                                                </div>
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                    <div className="col-md-3">
                                        <AnimationWrapper animation="fade-right" delay={0}>
                                            <div className="contact-info contact-card">
                                                <div className="icon">
                                                    <i className="fal fa-envelopes" />
                                                </div>
                                                <div className="content">
                                                    <h5>Email Us</h5>
                                                    <p>
                                                        <a
                                                            href="mailto:haroon.textile@gmail.com"
                                                            className="__cf_email__"
                                                        // data-cfemail="177e79717857726f767a677b723974787a"
                                                        >
                                                            {/* haroon.textile@gmail.com */}
                                                            {contact?.email}
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                    <div className="col-md-3">
                                        <AnimationWrapper animation="fade-right" delay={0.2}>
                                            <div className="contact-info contact-card">
                                                <div className="icon">
                                                    <i className="fal fa-alarm-clock" />
                                                </div>
                                                <div className="content">
                                                    <h5>Open Time</h5>
                                                    {/* <p>Mon - Sat (10.00AM - 05.30PM)</p> */}
                                                    <p>{contact?.openhours}</p>
                                                </div>
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-form-wrap">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <AnimationWrapper animation="fade-left" delay={0}>
                                            <div className="contact-img">
                                                <img src="assets/img/contact/01.jpg" alt="" />
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                    <div className="col-lg-7">
                                        <AnimationWrapper animation="fade-right" delay={0}>
                                            <div className="contact-form">
                                                <div className="contact-form-header">
                                                    <div className='d-flex justify-content-between'>
                                                        <h2>Get In Touch</h2>
                                                        <div className="">
                                                            {
                                                                contact?.qrcodecontact ? <img
                                                                    src={`${urls?.image}${contact?.qrcodecontact}`}
                                                                    // src="assets/img/qr/qr_contact.png"
                                                                    alt=""
                                                                    className=""
                                                                    style={{
                                                                        zIndex: '99',
                                                                        width: '100px'
                                                                    }}
                                                                /> :
                                                                    <img
                                                                        // src={`${urls?.image}${contact?.qrcodecontact}`}
                                                                        src="assets/img/qr/qr_contact.png"
                                                                        alt=""
                                                                        className=""
                                                                        style={{
                                                                            zIndex: '99',
                                                                            width: '100px'
                                                                        }}
                                                                    />
                                                            }

                                                        </div>
                                                    </div>

                                                    <p>
                                                        It is a long established fact that a reader will be
                                                        distracted by the readable content of a page randomised
                                                        words which don't look even slightly when looking at its
                                                        layout.{" "}
                                                    </p>
                                                </div>
                                                <div className="form-message" />
                                                <ContactForm />
                                                {/* <form
                                                method="post"
                                                action="https://live.themewild.com/solario/assets/php/contact.php"
                                                id="contact-form"
                                            >
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <div className="form-icon">
                                                                <i className="far fa-user-tie" />
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="name"
                                                                    placeholder="Your Name"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <div className="form-icon">
                                                                <i className="far fa-envelope" />
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="email"
                                                                    placeholder="Your Email"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-pen" />
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="phone"
                                                            placeholder="Your Phone"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-pen" />
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="subject"
                                                            placeholder="Your Subject"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-comment-lines" />
                                                        <textarea
                                                            name="message"
                                                            cols={30}
                                                            rows={5}
                                                            className="form-control"
                                                            placeholder="Write Your Message"
                                                            required
                                                            defaultValue={""}
                                                        />
                                                    </div>
                                                </div>
                                                <button type="submit" className="theme-btn">
                                                    Send Message <i className="far fa-paper-plane" />
                                                </button>
                                            </form> */}
                                            </div>
                                        </AnimationWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end contact area */}
                    {/* map */}
                    <AnimationWrapper animation="fade-up">
                        <div className="contact-map">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7301.7339156519!2d90.39217518857386!3d23.787751493286496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c712c919cd45%3A0x58c10ab1f9b6cf99!2z4Kaa4KeH4Kef4Ka-4Kaw4Kau4KeN4Kav4Ka-4KaoIOCmrOCmvuCnnOCmvywg4Kai4Ka-4KaV4Ka-IDEyMTI!5e0!3m2!1sbn!2sbd!4v1739785547392!5m2!1sbn!2sbd"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                            />
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7301.7339156519!2d90.39217518857386!3d23.787751493286496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c712c919cd45%3A0x58c10ab1f9b6cf99!2z4Kaa4KeH4Kef4Ka-4Kaw4Kau4KeN4Kav4Ka-4KaoIOCmrOCmvuCnnOCmvywg4Kai4Ka-4KaV4Ka-IDEyMTI!5e0!3m2!1sbn!2sbd!4v1739785547392!5m2!1sbn!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7301.7339156519!2d90.39217518857386!3d23.787751493286496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c712c919cd45%3A0x58c10ab1f9b6cf99!2z4Kaa4KeH4Kef4Ka-4Kaw4Kau4KeN4Kav4Ka-4KaoIOCmrOCmvuCnnOCmvywg4Kai4Ka-4KaV4Ka-IDEyMTI!5e0!3m2!1sbn!2sbd!4v1739785547392!5m2!1sbn!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                            {/* <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96708.34194156103!2d-74.03927096447748!3d40.759040329405195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4a01c8df6fb3cb8!2sSolomon%20R.%20Guggenheim%20Museum!5e0!3m2!1sen!2sbd!4v1619410634508!5m2!1sen!2s"

                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        /> */}
                        </div>
                    </AnimationWrapper>
                    {/* map end */}
                </main>
                {/* footer area */}
                {/* <footer className="footer-area">
                    <div className="footer-shape">
                        <img src="assets/img/shape/08.png" alt="" />
                    </div>
                    <div className="footer-widget">
                        <div className="container">
                            <div className="footer-widget-wrap pt-100 pb-80">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="footer-widget-box about-us">
                                            <a href="#" className="footer-logo">
                                                <img src="assets/img/logo/logo-light.png" alt="" />
                                            </a>
                                            <p className="mb-4">
                                                We are many variations of passages available but the majority
                                                have suffered alteration some form by injected humour words
                                                believable.
                                            </p>
                                            <div className="footer-newsletter">
                                                <h6>Subscribe Our Newsletter</h6>
                                                <div className="newsletter-form">
                                                    <form action="#">
                                                        <div className="form-group">
                                                            <div className="form-icon">
                                                                <i className="far fa-envelopes" />
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Your Email"
                                                                />
                                                                <button className="theme-btn" type="submit">
                                                                    Subscribe <span className="far fa-paper-plane" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-2">
                                        <div className="footer-widget-box list">
                                            <h4 className="footer-widget-title">Company</h4>
                                            <ul className="footer-list">
                                                <li>
                                                    <a href="about">
                                                        <i className="far fa-angle-double-right" />
                                                        About Us
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="blog">
                                                        <i className="far fa-angle-double-right" />
                                                        Update News
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="testimonial">
                                                        <i className="far fa-angle-double-right" />
                                                        Testimonials
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="contact">
                                                        <i className="far fa-angle-double-right" />
                                                        Contact Us
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="terms">
                                                        <i className="far fa-angle-double-right" />
                                                        Terms Of Service
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="privacy">
                                                        <i className="far fa-angle-double-right" />
                                                        Privacy policy
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-2">
                                        <div className="footer-widget-box list">
                                            <h4 className="footer-widget-title">Services</h4>
                                            <ul className="footer-list">
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Solar Panels
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Wind Generators
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Easy Installation
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Solar Maintenance
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Hydraulic Power
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Fossil Resources
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="footer-widget-box">
                                            <h4 className="footer-widget-title">Get In Touch</h4>
                                            <ul className="footer-contact">
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-location-dot" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Our Address</h6>
                                                        <p>25/AB Milford Road, New York, USA</p>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-phone" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Call Us</h6>
                                                        <a href="tel:"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-envelope" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Mail Us</h6>
                                                        <a href="https://live.themewild.com/cdn-cgi/l/email-protection#c4adaaa2ab84a1bca5a9b4a8a1eaa7aba9">
                                                            <span
                                                                className="__cf_email__"
                                                                data-cfemail="5b32353d341b3e233a362b373e75383436"
                                                            >
                                                                email
                                                            </span>
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="copyright">
                            <div className="row">
                                <div className="col-md-6 align-self-center">
                                    <p className="copyright-text">
                                        © Copyright <span id="date" /> <a href="#"> Solario </a> All
                                        Rights Reserved.
                                    </p>
                                </div>
                                <div className="col-md-6 align-self-center">
                                    <ul className="footer-social">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-x-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-youtube" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
                {/* footer area end */}
                {/* scroll-top */}
                <a href="#" id="scroll-top">
                    <i className="far fa-arrow-up" />
                </a>
                {/* scroll-top end */}
                {/* js */}
            </>


        </div>
    )
}